import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import Button from 'components/Button';
import { ROUTES } from 'utils/constants';
import styles from './NotFound.module.scss';

function NotFound() {
  const navigate = useNavigate();
  const location = useLocation();

  return (
    <div className={styles.container}>
      <div className={styles.card}>
        <div className={styles.illustration} aria-hidden="true">
          <svg
            className={styles.illustrationSvg}
            viewBox="0 0 640 220"
            role="img"
            focusable="false"
          >
            <defs>
              <linearGradient id="nf_grad" x1="0" y1="0" x2="1" y2="1">
                <stop offset="0%" stopColor="hsl(222.2 47.4% 11.2%)" />
                <stop offset="100%" stopColor="hsl(215 16% 35%)" />
              </linearGradient>
            </defs>

            {/* "Build-in" 404 made from accounting-like segments */}
            <g className={styles.buildStage}>
              <rect
                x="14"
                y="18"
                width="612"
                height="184"
                rx="20"
                fill="hsl(0 0% 100%)"
                stroke="hsl(215 20% 85%)"
                strokeOpacity="0.18"
                strokeWidth="1"
              />

              {/* subtle grid */}
              <g opacity="0.12" stroke="hsl(215 20% 85%)" strokeWidth="1">
                <line x1="60" y1="62" x2="580" y2="62" />
                <line x1="60" y1="102" x2="580" y2="102" />
                <line x1="60" y1="142" x2="580" y2="142" />
              </g>

              {/* 4 */}
              <g className={`${styles.digit} ${styles.digit4}`}>
                <rect
                  className={`${styles.seg} ${styles.segA}`}
                  x="150"
                  y="50"
                  width="16"
                  height="74"
                  rx="8"
                />
                <rect
                  className={`${styles.seg} ${styles.segB}`}
                  x="150"
                  y="110"
                  width="90"
                  height="16"
                  rx="8"
                />
                <rect
                  className={`${styles.seg} ${styles.segC}`}
                  x="224"
                  y="50"
                  width="16"
                  height="120"
                  rx="8"
                />
              </g>

              {/* 0 */}
              <g className={`${styles.digit} ${styles.digit0a}`}>
                <rect
                  className={`${styles.seg} ${styles.segD}`}
                  x="288"
                  y="50"
                  width="16"
                  height="120"
                  rx="8"
                />
                <rect
                  className={`${styles.seg} ${styles.segE}`}
                  x="288"
                  y="50"
                  width="96"
                  height="16"
                  rx="8"
                />
                <rect
                  className={`${styles.seg} ${styles.segF}`}
                  x="368"
                  y="50"
                  width="16"
                  height="120"
                  rx="8"
                />
                <rect
                  className={`${styles.seg} ${styles.segG}`}
                  x="288"
                  y="154"
                  width="96"
                  height="16"
                  rx="8"
                />
              </g>

              {/* 4 */}
              <g className={`${styles.digit} ${styles.digit4b}`}>
                <rect
                  className={`${styles.seg} ${styles.segH}`}
                  x="420"
                  y="50"
                  width="16"
                  height="74"
                  rx="8"
                />
                <rect
                  className={`${styles.seg} ${styles.segI}`}
                  x="420"
                  y="110"
                  width="90"
                  height="16"
                  rx="8"
                />
                <rect
                  className={`${styles.seg} ${styles.segJ}`}
                  x="494"
                  y="50"
                  width="16"
                  height="120"
                  rx="8"
                />
              </g>

              {/* Small "accounting objects" flying in */}
              <g className={styles.flying}>
                <rect
                  className={`${styles.obj} ${styles.obj1}`}
                  x="90"
                  y="44"
                  width="34"
                  height="22"
                  rx="6"
                  fill="hsl(210 20% 98%)"
                  stroke="hsl(215 20% 85%)"
                />
                <rect
                  className={`${styles.obj} ${styles.obj2}`}
                  x="520"
                  y="148"
                  width="38"
                  height="22"
                  rx="6"
                  fill="hsl(210 20% 98%)"
                  stroke="hsl(215 20% 85%)"
                />
                <circle
                  className={`${styles.obj} ${styles.obj3}`}
                  cx="104"
                  cy="162"
                  r="11"
                  fill="hsl(210 20% 98%)"
                  stroke="hsl(215 20% 85%)"
                />
                <circle
                  className={`${styles.obj} ${styles.obj4}`}
                  cx="544"
                  cy="62"
                  r="10"
                  fill="hsl(210 20% 98%)"
                  stroke="hsl(215 20% 85%)"
                />
              </g>
            </g>
          </svg>
        </div>
        <h1 className={styles.srOnly}>404</h1>
        <p className={styles.subtitle}>Page not found.</p>
        <div className={styles.path}>Looked for: {location.pathname}</div>

        <div className={styles.actions}>
          <Button onClick={() => navigate(ROUTES.HOME)}>Go home</Button>
          <Button variant="outline" onClick={() => navigate(-1)}>
            Go back
          </Button>
        </div>
      </div>
    </div>
  );
}

export default NotFound;
